module.exports = __webpack_public_path__ + "static/media/A.ae6833d1.jpg";